module.exports = __webpack_public_path__ + "img/p4.a71be716.png";